import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { WalletProvider } from './contexts/WalletContext'
import Header from './components/Header'
import ConnectWalletModal from './components/ConnectWalletModal'
import Home from './pages/Home'
import ChallengeDetail from './pages/ChallengeDetail'
import CreateChallenge from './pages/CreateChallenge'
import Gallery from './pages/Gallery'
import SubmitProof from './pages/SubmitProof'
import MyPage from './pages/MyPage'
import AdminDashboard from './pages/AdminDashboard'
import SettlementResult from './pages/SettlementResult'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 60_000, retry: 1 },
  },
})

export default function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <WalletProvider>
        <BrowserRouter>
          <div className="app">
            <Header />
            <main className="page">
              <div className="shell">
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/challenge/:address" element={<ChallengeDetail />} />
                  <Route path="/create" element={<CreateChallenge />} />
                  <Route path="/gallery/:address" element={<Gallery />} />
                  <Route path="/submit/:address" element={<SubmitProof />} />
                  <Route path="/my" element={<MyPage />} />
                  <Route path="/admin" element={<AdminDashboard />} />
                  <Route path="/result/:address" element={<SettlementResult />} />
                </Routes>
              </div>
            </main>
            <ConnectWalletModal />
          </div>
        </BrowserRouter>
      </WalletProvider>
    </QueryClientProvider>
  )
}
